import {
  Directive, ElementRef, Renderer2, HostListener, AfterViewInit,
  Input, Optional, Self, OnChanges, SimpleChanges
} from '@angular/core';
import { NgStyle } from '@angular/common';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[type=intnumber]',
    standalone: false
})
export class IntNumberDirective implements AfterViewInit, OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('style') styles;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, @Optional() @Self() private ngStyle: NgStyle) { }
  ngAfterViewInit() {
    if (this.styles) {
      if (this.styles.search('padding-left:') !== -1 || this.styles.search('padding-right:') !== -1) {
        this.styles.split(';').forEach(element => {
          const style = element.split(':');
          if (style[0].includes('padding-left')) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', style[1].trim());

          } else if (element.split(':')[0].includes('padding-right')) {
            this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', style[1].trim());
          }
        });
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '4px');
        this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '4px');
      }
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '4px');
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '4px');
    }

  }
  ngOnChanges(changes: SimpleChanges): void { }
  @HostListener('input', ['$event'])
  oninput(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
  @HostListener('keypress', ['$event'])
  keyPress(event: KeyboardEvent) {
    const pattern = /[0-9\+]/;

    const inputChar = event.key;
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
